import React from 'react';

const DistanceBackground = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="1876" height="237" viewBox="0 0 1876 237">
                <g><path d="M65.5,106h1745a65.51,65.51,0,0,1,65.5,65.5h0a65.51,65.51,0,0,1-65.5,65.5H65.5A65.51,65.51,0,0,1,0,171.5H0A65.51,65.51,0,0,1,65.5,106Z" fill="#00aa96"/></g>
                <g><path d="M72.5,53h1435A26.49,26.49,0,0,1,1534,79.5h0a26.49,26.49,0,0,1-26.5,26.5H72.5A26.49,26.49,0,0,1,46,79.5h0A26.49,26.49,0,0,1,72.5,53Z" fill="#1c2284"/></g>
                <g><path d="M72.5,0h1236A26.49,26.49,0,0,1,1335,26.5h0A26.49,26.49,0,0,1,1308.5,53H72.5A26.49,26.49,0,0,1,46,26.5h0A26.49,26.49,0,0,1,72.5,0Z" fill="#e62d82"/></g>
            </svg>
        </>
    );
}

export default DistanceBackground;
